import {
  BestPriceBuyerItem,
  IBestPriceBagItem,
} from '@/modules/mixing/store/analytical-mixing.store';

export class RecipesService {
  private readonly offer: BestPriceBuyerItem;
  private readonly sleeveData: IBestPriceBagItem;
  public readonly TAG_COLORS = {
    RED: 'rgb(248, 196, 198)',
    GREEN: 'rgb(179, 216, 197)',
    GREY: 'rgb(223, 230, 250)',
  };

  constructor(offer: BestPriceBuyerItem, sleeveData: IBestPriceBagItem) {
    this.offer = offer;
    this.sleeveData = sleeveData;
  }

  calculateDrainParams() {
    return {
      drainBefore: {
        weight: this.sleeveData.weight + this.sleeveData.weight_gain_tons,
        brutto:
          (this.sleeveData.weight + this.sleeveData.weight_gain_tons) *
          this.offer.price_per_ton,
        freightPrice: this.sleeveData.freight_cost_after_moisture_mod,
        netto:
          (this.sleeveData.weight + this.sleeveData.weight_gain_tons) *
            this.offer.price_per_ton -
          this.sleeveData.freight_cost_after_moisture_mod,
      },
      drainAfter: {
        weight: this.sleeveData.weight,
        brutto:
          (this.sleeveData.weight + this.sleeveData.weight_gain_tons) *
          this.offer.price_per_ton,
        freightPrice: this.sleeveData.freight_cost_before_moisture_mod,
        netto:
          (this.sleeveData.weight + this.sleeveData.weight_gain_tons) *
            this.offer.price_per_ton -
          this.sleeveData.freight_cost_before_moisture_mod,
      },
    };
  }

  calculateHydrateParams() {
    const weight_gain_tons = this.sleeveData.initial_weight_gain_tons || this.sleeveData.weight_gain_tons;
    return {
      original: {
        weight: this.sleeveData.weight,
        brutto: this.offer.price_per_ton * this.sleeveData.weight,
        freightPrice: this.sleeveData.freight_cost_before_moisture_mod,
        netto:
          this.offer.price_per_ton * this.sleeveData.weight -
          this.sleeveData.freight_cost_before_moisture_mod,
      },
      hydrateBefore: {
        weight: this.sleeveData.weight + +weight_gain_tons,
        brutto:
          this.offer.price_per_ton *
          (this.sleeveData.weight + +weight_gain_tons),
        freightPrice: this.sleeveData.freight_cost_after_moisture_mod,
        netto:
          this.offer.price_per_ton *
            (this.sleeveData.weight + +weight_gain_tons) -
          this.sleeveData.freight_cost_after_moisture_mod,
      },
      hydrateAfter: {
        weight: this.sleeveData.weight + +weight_gain_tons,
        brutto:
          this.offer.price_per_ton *
          (this.sleeveData.weight + +weight_gain_tons),
        freightPrice: this.sleeveData.freight_cost_before_moisture_mod,
        netto:
          this.offer.price_per_ton *
            (this.sleeveData.weight + +weight_gain_tons) -
          this.sleeveData.freight_cost_before_moisture_mod,
      },
    };
  }
}
